module.exports = __webpack_public_path__ + "static/Criminal Trial & Enquiries (Law, Practice & Procedure)-75bb1c6f719b58f141874b41b0f74224.jpg";